'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var OFFERING_TYPES = {
  EXPSTD: 'Expense - Standard',
  EXPPRO: 'Expense - Professional',
  INVSTD: 'Invoice - Standard',
  INVPRO: 'Invoice - Professional',
  TRVSTD: 'Travel - Standard',
  TRVPRO: 'Travel - Professional',
  TRQPRO: 'Travel Request - Professional',
  TRIPLINK: 'TripLink'
};

exports.default = OFFERING_TYPES;


//////////////////
// WEBPACK FOOTER
// ./lib/config/offeringTypes.js
// module id = 595
// module chunks = 0